<template>
  <div class="a_404 main-box text-center">
    <el-image
      :src="require('../assets/img/i.png')"
      fit="cover"
    ></el-image>
    <p>{{title}}</p>
  </div>
</template>

<script>
export default {
  name:"html404",
  props:{
    tit:{
      type: String,
      default: ""
    }
  },
  data(){
    return {
      "zh-CN":{
        title: this.tit||"资料筹备中，敬请期待..."
      },
      "en":{
        title: this.tit||"waiting time"
      }
    }
  },
  computed:{
    __lang(){
      return this.$route.params.lang;
    },
    title(){
      return this[this.__lang].title;
    }
  }
}
</script>

<style lang="less" scoped>
  .a_404{
    width: 100%;
    padding: 100px 0;
  }
</style>
